// src/services/uploadHelper.js
// Upload direto para o Hostgator — mais rápido que base64 via GAS

const UPLOAD_URL = 'https://www.paroquiademessejana.com.br/upload.php';
const UPLOAD_CHAVE = 'paroquia2024';

/**
 * Faz upload de um único arquivo para o Hostgator
 * @param {File} file - arquivo a ser enviado
 * @param {string} pasta - subpasta destino (ex: 'batismo/Junho_2026/certidoes')
 * @returns {Promise<string>} URL pública do arquivo
 */
export const uploadArquivo = async (file, pasta) => {
  const fd = new FormData();
  fd.append('arquivo', file);
  fd.append('chave', UPLOAD_CHAVE);
  fd.append('pasta', pasta);

  const res = await fetch(UPLOAD_URL, { method: 'POST', body: fd });
  const json = await res.json();
  if (!json.success) throw new Error(json.message || 'Erro no upload.');
  return json.url;
};

/**
 * Faz upload de múltiplos arquivos e retorna array de URLs
 */
export const uploadMultiplos = async (files, pasta) => {
  const urls = [];
  for (const file of files) {
    const url = await uploadArquivo(file, pasta);
    urls.push(url);
  }
  return urls;
};
